function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.306,
  y1: 0.514,
  x2: 0.337,
  y2: 0.764,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#714df4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2ac2ea"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.472,
  y1: 0.519,
  x2: 0.206,
  y2: 0.67,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f251b4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-Design_2_-_Vector"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1050,
  height: 600
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Design_2_-_Vector",
  "data-name": "Design 2 - Vector",
  clipPath: "url(#clip-Design_2_-_Vector)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1050,
  height: 600,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M1496.24,861.682C710.377,1310.9-549.2,1007.189-549.2,1007.189S-1149.281,2768.6-75.337,2432.351s2040.1,0,2040.1,0,480.817-2091.944,363.4-2328.763S2282.1,412.469,1496.24,861.682Z",
  transform: "translate(-572.487 -999.525) rotate(-27)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_39",
  "data-name": "Path 39",
  d: "M0,0H2580V2780H0Z",
  transform: "translate(-163 -1390)",
  fill: "url(#linear-gradient-2)"
}));
function SvgBackgroundGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1050,
    height: 600,
    viewBox: "0 0 1050 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGradient);
export default __webpack_public_path__ + "static/media/background-gradient.d2ff360c223618b3b3ac3cccedf0c456.svg";
export { ForwardRef as ReactComponent };